/**
 * Local-storage backed draft persistence for Billing v2.
 * Keyed per-clinic so multiple users / tenants on the same browser don't collide.
 */
const KEY_PREFIX = "hedesk:billing-draft:";

export function loadDraft(clinicId) {
  try {
    const raw = localStorage.getItem(KEY_PREFIX + clinicId);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveDraft(clinicId, draft) {
  try {
    if (!draft || (!draft.patient && (draft.items || []).length === 0)) {
      localStorage.removeItem(KEY_PREFIX + clinicId);
      return;
    }
    localStorage.setItem(KEY_PREFIX + clinicId, JSON.stringify({ ...draft, savedAt: Date.now() }));
  } catch {
    /* ignore quota errors */
  }
}

export function clearDraft(clinicId) {
  try { localStorage.removeItem(KEY_PREFIX + clinicId); } catch {}
}
